module.exports = __webpack_public_path__ + "img/ford-logo.104483fa.png";